import React, {useContext} from "react";
import {setPageInfo} from '../Functions/Helpers';
import {WooContext} from "../WooContext";
import {ICON_DOWN_ARROW} from '../SVG/consts';
import SvgLink from "../SVG";

function Pagination({products}) {

    const {pagedState} = useContext(WooContext);

    if (!products.data || !products.data.products || !products.data.products.pageInfo) {
        return [];
    }

    const [paged, setPaged] = pagedState;
    const pagination = products.data.products.pageInfo.offsetPagination||{};

    if (!pagination.total || pagination.total <= paged.size) {
        return [];
    }

    let rows = [];

    const currentPage = Math.floor(parseInt(paged.offset / paged.size));

    for (var i = 0; i < (pagination.total / paged.size); i++) {
        rows.push(
            <li key={`pagination-item-${i}`}
                className={currentPage === i ? 'pagination-item pagination-item-current' : 'pagination-item'}>
            <a data-offset-number={i}
               href={`${window.location.pathname}?wrPerPage=${paged.size}&wrPage=${i}`}
               onClick={(e)=> {
                   e.preventDefault();
                   const pageNumber = e.target.dataset.offsetNumber;
                   const pagedUri = `${window.location.pathname}?wrPerPage=${paged.size}&wrPage=${pageNumber}`;
                   setPaged(prevPage => ({size: parseInt(prevPage.size), offset: (pageNumber * prevPage.size)}));
                   setPageInfo(pagedUri);
               }}>
                {(i+1)}
            </a>
        </li>);
    }
    return (
        <>
        {!products.loading &&
        <ul className="pagination">
            {pagination.hasPrevious &&
            <li className="pagination-prev">
                <button onClick={()=> {
                setPaged(prevPage => ({size: parseInt(prevPage.size), offset: (prevPage.offset - prevPage.size)}));
                const pagedUri = `${window.location.pathname}?wrPerPage=${paged.size}&wrPage=${currentPage-1}`;
                setPageInfo(pagedUri);}}>
                    <SvgLink {...ICON_DOWN_ARROW} />
                </button>
            </li>}
            {rows}
            {pagination.hasMore &&
            <li className="pagination-next">
                <button onClick={()=> {
                setPaged(prevPage => ({size: parseInt(prevPage.size), offset: (parseInt(prevPage.offset) + parseInt(prevPage.size))}));
                const pagedUri = `${window.location.pathname}?wrPerPage=${paged.size}&wrPage=${currentPage+1}`;
                setPageInfo(pagedUri);}}>
                    <SvgLink {...ICON_DOWN_ARROW} />
                </button>
            </li>}
        </ul>}
        </>
    );
}

export default Pagination;